module.exports = __webpack_public_path__ + "static/DJS2-692d6450fefce66a1f5d5540165eb175.png";